import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import './style.css';

import { Balance } from './Balance';
import { Landing } from './Landing';
import { PaymentReceipt } from './PaymentReceipt'

export class Content extends Component {
    render() {
        return (
            <Router>
                <div id="content">
                    <Switch>
                        <Route path={"/Landing"} component={Landing}></Route>
                        <Route path={"/Balance"} component={Balance} ></Route>
                        <Route path={"/PaymentReceipt/:paymentId"} component={PaymentReceipt}></Route>
                        <Route path={"/"} component={Landing} ></Route>
                    </Switch>
                </div>
            </Router>
        );
    }
}